import React from 'react';

interface IProps {
  children: React.ReactNode,
}

const HeaderRowWrapper = ({ children }: IProps) => (
  <tr>
    { children }
  </tr>
);

export default HeaderRowWrapper;
